import React, {Component} from 'react'

class Help010 extends Component {
  constructor (props) {
    super(props)
    document.querySelector("meta[name='viewport']").setAttribute('content', 'width=1158px,shrink-to-fit=yes')
  }
  render () {
    return (
      <div className='container-fluid'>
        <div className='row-fluid'>
          <div className='span1' />
          <div className='span14 help-area'>
            <div className='page-header'>
              <h2><i className='icon-question-sign icon-large' />サポート対象のホームページ閲覧ソフトChromeをダウンロードする</h2>
            </div>{/* ./page-header */}
            <div className='blockoff-left'>
              <legend className='lead'><span className='label label-warning'>[10-1]</span>サポート対象外のブラウザでアクセスすると警告画面が表示されます。その中のリンク(図10-1 参照)を押すとダウンロード用の画面が表示されます。</legend>
              <figcaption>図10-1</figcaption>
              <ul>
                <li><img alt='' src='/help/help_10-1.png' /></li>
              </ul>
            </div>{/* ./blockoff-left */}
          </div>{/* ./help-area */}
        </div>
      </div>
    )
  }
}

export default Help010



// WEBPACK FOOTER //
// ./src/help/Help010.js